import React, { useEffect } from "react";

const PrintFile = () => {

    useEffect(() => {
        const tmp = localStorage.getItem('printContent');

        if (tmp) {
            localStorage.removeItem('printContent'); // Opcional: eliminar los datos después de recuperarlos
            document.title = JSON.parse(tmp).name;
            document.body.style.backgroundColor = '#fff';
            document.body.innerHTML = JSON.parse(tmp).printContents;
            setTimeout(() => {
                window.print();
            }, 500);
        }
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: '60px' }}>
            {/* <h5 style={{ maxWidth: '800px' }}>Los trabajadores de la Televisión y la radio llevaremos acabo a nuestra
                sexagésima octava asamblea general ordinaria del concejo nacional en Quintana Roo,
                inaugurando los trabajos del gobernador del estado, con el respaldo de la confederación
                de trabajadores de México, avanzamos para un mejor futuro comprometidos contigo,
                por una superación social.</h5> */}
        </div>
    );
}

export default PrintFile;